import { render } from "./user_page.vue?vue&type=template&id=50f9f445&scoped=true"
import script from "./user_page.vue?vue&type=script&lang=js"
export * from "./user_page.vue?vue&type=script&lang=js"

import "./user_page.vue?vue&type=style&index=0&id=50f9f445&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50f9f445"]])

export default __exports__